/*
  Bell Composer behavior.
  Do not change JS outside the specified functions.
*/

    (() => {
      const C_MAJOR_NOTE_ORDER = ["shh", "C", "D", "E", "F", "G", "A", "B", "c"];
      // 25-note ordering from low G to high G.
      const CHROMATIC_NOTE_ORDER = [
        "shh", "low_g", "low_g#", "low_a", "low_a#", "low_b",
        "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B", "c",
        "high_c#", "high_d", "high_d#", "high_e", "high_f", "high_f#", "high_g"
      ];
      const CHROMATIC_WHITE_NOTES = [
        "shh", "low_g", "low_a", "low_b", "C", "D", "E", "F",
        "G", "A", "B", "c", "high_d", "high_e", "high_f", "high_g"
      ];
      const CHROMATIC_BLACK_NOTES = [
        { note: "low_g#", afterWhiteIndex: 1 },
        { note: "low_a#", afterWhiteIndex: 2 },
        { note: "C#", afterWhiteIndex: 4 },
        { note: "D#", afterWhiteIndex: 5 },
        { note: "F#", afterWhiteIndex: 7 },
        { note: "G#", afterWhiteIndex: 8 },
        { note: "A#", afterWhiteIndex: 9 },
        { note: "high_c#", afterWhiteIndex: 11 },
        { note: "high_d#", afterWhiteIndex: 12 },
        { note: "high_f#", afterWhiteIndex: 14 }
      ];
      const C_MAJOR_KEYBOARD_DIGITS = {
        Digit1: "C",
        Digit2: "D",
        Digit3: "E",
        Digit4: "F",
        Digit5: "G",
        Digit6: "A",
        Digit7: "B",
        Digit8: "c"
      };
      const NOTE_LABELS_SHARP = {
        "shh": "Shh",
        "low_g": "Low G",
        "low_g#": "Low G#",
        "low_a": "Low A",
        "low_a#": "Low A#",
        "low_b": "Low B",
        "C": "C",
        "C#": "C#",
        "D": "D",
        "D#": "D#",
        "E": "E",
        "F": "F",
        "F#": "F#",
        "G": "G",
        "G#": "G#",
        "A": "A",
        "A#": "A#",
        "B": "B",
        "c": "High C",
        "high_c#": "High C#",
        "high_d": "High D",
        "high_d#": "High D#",
        "high_e": "High E",
        "high_f": "High F",
        "high_f#": "High F#",
        "high_g": "High G"
      };
      const NOTE_LABELS_FLAT = {
        "low_g#": "Low Ab",
        "low_a#": "Low Bb",
        "C#": "Db",
        "D#": "Eb",
        "F#": "Gb",
        "G#": "Ab",
        "A#": "Bb",
        "high_c#": "High Db",
        "high_d#": "High Eb",
        "high_f#": "High Gb"
      };
      const STORAGE_KEY = "bell_melody_saved_patterns_v1";
      const NOTE_COLORS = {
        "shh": "#aab6cb",
        "low_g": "#30c8c9",
        "low_g#": "#27b3b4",
        "low_a": "#5b6bff",
        "low_a#": "#4f5de0",
        "low_b": "#9b5bff",
        "C": "#ff5b5b",
        "C#": "#f64f4f",
        "D": "#ff9f43",
        "D#": "#f08f35",
        "E": "#ffd93d",
        "F": "#64d97a",
        "F#": "#55c96b",
        "G": "#30c8c9",
        "G#": "#27b3b4",
        "A": "#5b6bff",
        "A#": "#4f5de0",
        "B": "#9b5bff",
        "c": "#ff5bbd",
        "high_c#": "#eb4ea8",
        "high_d": "#ff9f43",
        "high_d#": "#f08f35",
        "high_e": "#ffd93d",
        "high_f": "#64d97a",
        "high_f#": "#55c96b",
        "high_g": "#30c8c9"
      };
      const NOTE_ASSETS = {
        "shh": { image: "bc_shh_bell.png", activeImage: "bc_shh_bell_active.png", sound: "" },
        "low_g": { image: "bc_bell_low_g.png", activeImage: "bc_bell_low_g_active.png", sound: "mp3/bc_low_g_bell_sound.mp3" },
        "low_g#": { image: "bc_bell_low_g_sharp.png", activeImage: "bc_bell_low_g_sharp_active.png", sound: "mp3/bc_low_g_sharp_bell_sound.mp3" },
        "low_a": { image: "bc_bell_low_a.png", activeImage: "bc_bell_low_a_active.png", sound: "mp3/bc_low_a_bell_sound.mp3" },
        "low_a#": { image: "bc_bell_low_a_sharp.png", activeImage: "bc_bell_low_a_sharp_active.png", sound: "mp3/bc_low_a_sharp_bell_sound.mp3" },
        "low_b": { image: "bc_bell_low_b.png", activeImage: "bc_bell_low_b_active.png", sound: "mp3/bc_low_b_bell_sound.mp3" },
        "C": { image: "bc_bell_c.png", activeImage: "bc_bell_c_active.png", sound: "mp3/bc_c_bell_sound.mp3" },
        "C#": { image: "bc_bell_c_sharp.png", activeImage: "bc_bell_c_sharp_active.png", sound: "mp3/bc_c_sharp_bell_sound.mp3" },
        "D": { image: "bc_bell_d.png", activeImage: "bc_bell_d_active.png", sound: "mp3/bc_d_bell_sound.mp3" },
        "D#": { image: "bc_bell_d_sharp.png", activeImage: "bc_bell_d_sharp_active.png", sound: "mp3/bc_d_sharp_bell_sound.mp3" },
        "E": { image: "bc_bell_e.png", activeImage: "bc_bell_e_active.png", sound: "mp3/bc_e_bell_sound.mp3" },
        "F": { image: "bc_bell_f.png", activeImage: "bc_bell_f_active.png", sound: "mp3/bc_f_bell_sound.mp3" },
        "F#": { image: "bc_bell_f_sharp.png", activeImage: "bc_bell_f_sharp_active.png", sound: "mp3/bc_f_sharp_bell_sound.mp3" },
        "G": { image: "bc_bell_g.png", activeImage: "bc_bell_g_active.png", sound: "mp3/bc_g_bell_sound.mp3" },
        "G#": { image: "bc_bell_g_sharp.png", activeImage: "bc_bell_g_sharp_active.png", sound: "mp3/bc_g_sharp_bell_sound.mp3" },
        "A": { image: "bc_bell_a.png", activeImage: "bc_bell_a_active.png", sound: "mp3/bc_a_bell_sound.mp3" },
        "A#": { image: "bc_bell_high_a_sharp.png", activeImage: "bc_bell_high_a_sharp_active.png", sound: "mp3/bc_a_sharp_bell_sound.mp3" },
        "B": { image: "bc_bell_b.png", activeImage: "bc_bell_b_active.png", sound: "mp3/bc_b_bell_sound.mp3" },
        "c": { image: "bc_bell_high_c.png", activeImage: "bc_bell_high_c_active.png", sound: "mp3/bc_high_c_bell_sound.mp3" },
        "high_c#": { image: "bc_bell_high_c_sharp.png", activeImage: "bc_bell_high_c_sharp_active.png", sound: "mp3/bc_high_c_sharp_bell_sound.mp3" },
        "high_d": { image: "bc_bell_high_d.png", activeImage: "bc_bell_high_d_active.png", sound: "mp3/bc_high_d_bell_sound.mp3" },
        "high_d#": { image: "bc_bell_high_d_sharp.png", activeImage: "bc_bell_high_d_sharp_active.png", sound: "mp3/bc_high_d_sharp_bell_sound.mp3" },
        "high_e": { image: "bc_bell_high_e.png", activeImage: "bc_bell_high_e_active.png", sound: "mp3/bc_high_e_bell_sound.mp3" },
        "high_f": { image: "bc_bell_high_f.png", activeImage: "bc_bell_high_f_active.png", sound: "mp3/bc_high_f_bell_sound.mp3" },
        "high_f#": { image: "bc_bell_high_f_sharp.png", activeImage: "bc_bell_high_f_sharp_active.png", sound: "mp3/bc_high_f_sharp_bell_sound.mp3" },
        "high_g": { image: "bc_bell_high_g.png", activeImage: "bc_bell_high_g_active.png", sound: "mp3/bc_high_g_bell_sound.mp3" }
      };
      // Shopify-ready asset config.
      // Option A (edit this file): set your Shopify Files CDN base URLs below.
      // Option B: define window.BELL_COMPOSER_ASSET_BASE before this script runs.
      function inferAssetBaseUrlFromScript() {
        const currentSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : "";
        const fallbackSrc = Array.from(document.scripts || [])
          .map((scriptEl) => scriptEl && scriptEl.src ? scriptEl.src : "")
          .find((src) => /bell-composer\.js(\?|$)/i.test(src));
        const src = currentSrc || fallbackSrc || "";
        if (!src) return "";
        const noQuery = src.split("?")[0];
        const slashIndex = noQuery.lastIndexOf("/");
        if (slashIndex < 0) return "";
        return noQuery.slice(0, slashIndex + 1);
      }

      const SHOPIFY_ASSET_BASE_DEFAULTS = (() => {
        const isLocalFile = window.location.protocol === "file:";
        const inferredBase = normalizeBaseUrl(inferAssetBaseUrlFromScript());
        return {
          imageBaseUrl: isLocalFile ? "" : (inferredBase || "/assets/"),
          soundBaseUrl: isLocalFile ? "" : (inferredBase || "/assets/")
        };
      })();
      const SHOPIFY_ASSET_BASE = window.BELL_COMPOSER_ASSET_BASE || SHOPIFY_ASSET_BASE_DEFAULTS;
      const shopifyImageBase = normalizeBaseUrl(SHOPIFY_ASSET_BASE.imageBaseUrl || SHOPIFY_ASSET_BASE.baseUrl || "");
      const shopifySoundBase = normalizeBaseUrl(SHOPIFY_ASSET_BASE.soundBaseUrl || SHOPIFY_ASSET_BASE.baseUrl || "");
      const soundBaseIsThemeAssets = /\/assets\/(?:$|[?#])/i.test(shopifySoundBase);
      const shopifyFilesSoundBase = normalizeBaseUrl(
        window.BELL_COMPOSER_FILES_SOUND_BASE || "https://cdn.shopify.com/s/files/1/0424/1021/3528/files/"
      );

      const MIN_MEASURES = 2;
      const MAX_MEASURES = 16;
      const MIN_BPM = 60;
      const MAX_BPM = 180;
      const NOTE_VOICES_PER_SOUND = 3;

      const refs = {
        gameScreen: document.getElementById("gameScreen"),
        bootLoader: document.getElementById("bootLoader"),
        bootLoaderText: document.getElementById("bootLoaderText"),
        progressText: document.getElementById("progressText"),
        helpUi: document.getElementById("helpUi"),
        helpBtn: document.getElementById("helpBtn"),
        helpPopover: document.getElementById("helpPopover"),
        printTitle: document.getElementById("printTitle"),
        message: document.getElementById("message"),
        cMajorModeBtn: document.getElementById("cMajorModeBtn"),
        chromaticModeBtn: document.getElementById("chromaticModeBtn"),
        noteNamesGroup: document.getElementById("noteNamesGroup"),
        sharpModeBtn: document.getElementById("sharpModeBtn"),
        flatModeBtn: document.getElementById("flatModeBtn"),
        countInOffBtn: document.getElementById("countInOffBtn"),
        countIn1Btn: document.getElementById("countIn1Btn"),
        countIn2Btn: document.getElementById("countIn2Btn"),
        measureSlider: document.getElementById("measureSlider"),
        measureValue: document.getElementById("measureValue"),
        tempoSlider: document.getElementById("tempoSlider"),
        tempoValue: document.getElementById("tempoValue"),
        slotsWrap: document.getElementById("slotsWrap"),
        slotsGrid: document.getElementById("slotsGrid"),
        measureOverlays: document.getElementById("measureOverlays"),
        playhead: document.getElementById("playhead"),
        countInOverlay: document.getElementById("countInOverlay"),
        bankGrid: document.getElementById("bankGrid"),
        playBtn: document.getElementById("playBtn"),
        stopBtn: document.getElementById("stopBtn"),
        loopBtn: document.getElementById("loopBtn"),
        undoBtn: document.getElementById("undoBtn"),
        clearBtn: document.getElementById("clearBtn"),
        copyLinkBtn: document.getElementById("copyLinkBtn"),
        printBtn: document.getElementById("printBtn"),
        patternNameInput: document.getElementById("patternNameInput"),
        loadPatternBtn: document.getElementById("loadPatternBtn"),
        savePatternBtn: document.getElementById("savePatternBtn"),
        savedPanel: document.getElementById("savedPanel"),
        savedList: document.getElementById("savedList")
      };

      let measures = 4;
      let tempoBpm = 100;
      let countInBars = 0;
      let useChromatic = true;
      let useFlats = false;
      // Melody timeline: each beat can hold one quarter note or two eighth notes.
      let slotNotes = new Array(getTotalBeats()).fill(null);
      let savedPatterns = [];

      // Drag state for touch/mouse/stylus pointer interactions.
      let dragState = null;

      // Audio state.
      let audioCtx = null;
      let audioAssetsLoaded = false;
      let audioPreloadPromise = null;
      let htmlAudioPrimed = false;
      let notePlayers = {};

      // Playback state.
      let isPlaying = false;
      let isCountingIn = false;
      let playTimers = [];
      let activeNoteEls = new Set();
      let loopPlayback = false;
      let celebratedCompositionKey = "";

      // One-level-plus undo history for timeline edits.
      let undoStack = [];
      const MAX_UNDO = 120;

      let messageTimer = 0;

      init();

      function init() {
        document.body.classList.add("bell-composer-page");
        refs.measureSlider.min = String(MIN_MEASURES);
        refs.measureSlider.max = String(MAX_MEASURES);
        refs.tempoSlider.min = String(MIN_BPM);
        refs.tempoSlider.max = String(MAX_BPM);
        refs.measureSlider.value = String(measures);
        refs.tempoSlider.value = String(tempoBpm);
        loadSavedPatterns();
        applyStateFromHash();
        updateSettingDisplays();
        updateScaleModeButtons();
        updateNameModeButtons();
        updateCountInButtons();
        updateMetaText();
        buildSlots();
        buildBank();
        showBootLoader("Loading bell sounds...");
        preloadAudioAssets().finally(() => {
          hideBootLoader();
        });
        renderSavedPatterns();
        bindEvents();
        updateLoopButton();
        updateUndoButton();
      }

      function buildSlots() {
        refs.slotsGrid.innerHTML = "";
        refs.playhead.hidden = true;
        for (let i = 0; i < getTotalBeats(); i++) {
          const slot = document.createElement("div");
          slot.className = "slot";
          if ((i + 1) % 4 === 0) slot.classList.add("measure-edge");
          if (i % 8 === 4) slot.classList.add("measure-start");
          slot.dataset.index = String(i);
          refs.slotsGrid.appendChild(slot);
        }
        renderSlots();
      }

      function buildBank() {
        refs.bankGrid.innerHTML = "";
        if (!useChromatic) {
          refs.bankGrid.className = "bank-grid bank-strip c-major-strip";
          C_MAJOR_NOTE_ORDER.forEach((noteId) => {
            const noteEl = createNoteElement(noteId, "bank");
            refs.bankGrid.appendChild(noteEl);
          });
          return;
        }

        refs.bankGrid.className = "bank-grid chromatic-piano";
        refs.bankGrid.appendChild(createChromaticPianoStrip());
      }

      function createChromaticPianoStrip() {
        const strip = document.createElement("div");
        strip.className = "chromatic-piano-strip";
        strip.style.setProperty("--white-count", String(CHROMATIC_WHITE_NOTES.length));

        const whiteRow = document.createElement("div");
        whiteRow.className = "chromatic-white-row";
        CHROMATIC_WHITE_NOTES.forEach((noteId) => {
          const noteEl = createNoteElement(noteId, "bank");
          noteEl.classList.add("chromatic-white-note");
          whiteRow.appendChild(noteEl);
        });

        const blackRow = document.createElement("div");
        blackRow.className = "chromatic-black-row";
        const noteSize = getCssPx("--bank-note-size", 62);
        const noteGap = getCssPx("--bank-note-gap", 8);

        CHROMATIC_BLACK_NOTES.forEach((entry) => {
          if (!NOTE_ASSETS[entry.note]) return;
          const left = ((entry.afterWhiteIndex + 1) * noteSize) + (entry.afterWhiteIndex * noteGap) + (noteGap / 2);

          const wrap = document.createElement("div");
          wrap.className = "chromatic-black-wrap";
          wrap.style.left = left + "px";

          const noteEl = createNoteElement(entry.note, "bank");
          noteEl.classList.add("chromatic-black-note");
          wrap.appendChild(noteEl);
          blackRow.appendChild(wrap);
        });

        strip.appendChild(blackRow);
        strip.appendChild(whiteRow);
        return strip;
      }

      function bindEvents() {
        refs.helpBtn.addEventListener("click", (event) => {
          event.stopPropagation();
          refs.helpUi.classList.toggle("open");
        });
        document.addEventListener("click", (event) => {
          if (!refs.helpUi.contains(event.target)) {
            refs.helpUi.classList.remove("open");
          }
          if (!refs.savedPanel.hidden && !refs.savedPanel.contains(event.target) && event.target !== refs.loadPatternBtn) {
            refs.savedPanel.hidden = true;
            refs.loadPatternBtn.classList.remove("active");
          }
        });
        refs.loadPatternBtn.addEventListener("click", (event) => {
          event.stopPropagation();
          const nextHidden = !refs.savedPanel.hidden;
          refs.savedPanel.hidden = nextHidden;
          refs.loadPatternBtn.classList.toggle("active", !nextHidden);
        });
        refs.savedPanel.addEventListener("click", (event) => {
          event.stopPropagation();
        });

        refs.cMajorModeBtn.addEventListener("click", () => {
          setScaleMode(false);
        });

        refs.chromaticModeBtn.addEventListener("click", () => {
          setScaleMode(true);
        });

        refs.sharpModeBtn.addEventListener("click", () => {
          setNameMode(false);
        });

        refs.flatModeBtn.addEventListener("click", () => {
          setNameMode(true);
        });

        refs.countInOffBtn.addEventListener("click", () => {
          setCountInBars(0);
        });

        refs.countIn1Btn.addEventListener("click", () => {
          setCountInBars(1);
        });

        refs.countIn2Btn.addEventListener("click", () => {
          setCountInBars(2);
        });

        refs.measureSlider.addEventListener("input", () => {
          const nextMeasures = Number(refs.measureSlider.value);
          if (!Number.isFinite(nextMeasures)) return;
          setMeasures(nextMeasures);
        });

        refs.tempoSlider.addEventListener("input", () => {
          const nextTempo = Number(refs.tempoSlider.value);
          if (!Number.isFinite(nextTempo)) return;
          tempoBpm = clamp(nextTempo, MIN_BPM, MAX_BPM);
          updateSettingDisplays();
          updateMetaText();
        });

        refs.playBtn.addEventListener("click", () => {
          unlockAudio();
          preloadAudioAssets();
          playMelody();
        });

        refs.stopBtn.addEventListener("click", () => {
          stopMelody();
          showMessage("Stopped.", 700);
        });

        refs.loopBtn.addEventListener("click", () => {
          loopPlayback = !loopPlayback;
          updateLoopButton();
          showMessage(loopPlayback ? "Loop on." : "Loop off.", 700);
        });

        refs.undoBtn.addEventListener("click", () => {
          if (!undoStack.length) return;
          stopMelody();
          const previous = undoStack.pop();
          slotNotes = cloneTimeline(previous);
          renderSlots();
          updateUndoButton();
          showMessage("Undid last change.", 700);
        });

        refs.clearBtn.addEventListener("click", () => {
          if (slotNotes.some((beat) => normalizeBeatValue(beat).length > 0)) {
            pushUndoSnapshot(cloneTimeline(slotNotes));
          }
          stopMelody();
          slotNotes = new Array(getTotalBeats()).fill(null);
          renderSlots();
          updateUndoButton();
          showMessage("Cleared.", 800);
        });

        refs.copyLinkBtn.addEventListener("click", async () => {
          const url = buildShareUrl(captureState());
          const ok = await copyText(url);
          showMessage(ok ? "Share link copied!" : "Link ready to copy.", 1200);
        });

        refs.printBtn.addEventListener("click", () => {
          printPattern();
        });

        refs.savePatternBtn.addEventListener("click", () => {
          const name = refs.patternNameInput.value.trim() || autoPatternName();
          const pattern = {
            id: String(Date.now() + Math.floor(Math.random() * 1000)),
            name,
            createdAt: Date.now(),
            state: captureState()
          };
          savedPatterns.unshift(pattern);
          if (savedPatterns.length > 60) savedPatterns = savedPatterns.slice(0, 60);
          persistSavedPatterns();
          renderSavedPatterns();
          showMessage("Song saved.", 1000);
        });

        // Pointer-based drag supports iPad Safari and desktop.
        document.addEventListener("pointerdown", onPointerDown);
        document.addEventListener("keydown", onKeyDown);
        window.addEventListener("resize", () => {
          renderMeasureOverlays();
        });

        // Tap slot itself to clear that beat.
        refs.slotsGrid.addEventListener("click", (event) => {
          const accentBtn = event.target.closest(".accent-toggle-btn");
          if (accentBtn) {
            const noteEl = accentBtn.closest(".slot-note");
            const slotEl = accentBtn.closest(".slot");
            if (!noteEl || !slotEl) return;
            const i = Number(slotEl.dataset.index);
            const subIndex = Number(noteEl.dataset.slotSubIndex || "0");
            const before = cloneTimeline(slotNotes);
            const toggled = toggleAccentOnBeat(i, subIndex);
            if (!toggled) return;
            renderSlots();
            pushUndoSnapshot(before);
            updateUndoButton();
            showMessage((toggled.accented ? "Accent on: " : "Accent off: ") + getNoteCode(toggled.note), 850);
            return;
          }

          const slotEl = event.target.closest(".slot");
          if (!slotEl) return;
          const i = Number(slotEl.dataset.index);
          const noteEl = event.target.closest(".slot-note");

          if (noteEl) {
            const before = cloneTimeline(slotNotes);
            const subIndex = Number(noteEl.dataset.slotSubIndex || "0");
            const noteId = noteEl.dataset.note;
            if (event.shiftKey) {
              const toggled = toggleAccentOnBeat(i, subIndex);
              if (!toggled) return;
              renderSlots();
              pushUndoSnapshot(before);
              updateUndoButton();
              showMessage((toggled.accented ? "Accent on: " : "Accent off: ") + getNoteCode(toggled.note), 850);
              return;
            }
            removeNoteFromBeat(i, subIndex, noteId);
            renderSlots();
            pushUndoSnapshot(before);
            updateUndoButton();
            showMessage("Removed " + getNoteCode(noteId), 700);
            return;
          }

          if (getBeatNotes(i).length) {
            const before = cloneTimeline(slotNotes);
            setBeatNotes(i, []);
            renderSlots();
            pushUndoSnapshot(before);
            updateUndoButton();
            showMessage("Beat " + (i + 1) + " cleared.", 700);
          }
        });

        refs.savedList.addEventListener("click", async (event) => {
          const btn = event.target.closest("button[data-action]");
          if (!btn) return;
          const id = btn.dataset.id;
          const action = btn.dataset.action;
          const pattern = savedPatterns.find((p) => p.id === id);
          if (!pattern) return;

          if (action === "load") {
            applyState(pattern.state);
            refs.savedPanel.hidden = true;
            refs.loadPatternBtn.classList.remove("active");
            showMessage("Pattern loaded.", 1100);
            return;
          }

          if (action === "share") {
            const url = buildShareUrl(pattern.state);
            const ok = await copyText(url);
            showMessage(ok ? "Pattern link copied!" : "Link ready to copy.", 1200);
            return;
          }

          if (action === "delete") {
            savedPatterns = savedPatterns.filter((p) => p.id !== id);
            persistSavedPatterns();
            renderSavedPatterns();
            showMessage("Pattern deleted.", 900);
          }
        });
      }

      function renderSlots() {
        activeNoteEls.clear();
        const slotEls = refs.slotsGrid.querySelectorAll(".slot");
        slotEls.forEach((slotEl) => {
          const i = Number(slotEl.dataset.index);
          const notes = getBeatNotes(i);
          slotEl.classList.toggle("filled", notes.length > 0);
          slotEl.innerHTML = "";

          const num = document.createElement("span");
          num.className = "slot-num";
          num.textContent = String((i % 4) + 1);
          slotEl.appendChild(num);

          if (!notes.length) {
            const rest = document.createElement("span");
            rest.className = "slot-rest";
            rest.textContent = "rest";
            slotEl.appendChild(rest);
          } else if (notes.length === 1) {
            const noteEl = createNoteElement(notes[0].note, "slot", {
              slotSubIndex: 0,
              accented: notes[0].accented
            });
            slotEl.appendChild(noteEl);
          } else {
            const duo = document.createElement("div");
            duo.className = "slot-duo";

            notes.slice(0, 2).forEach((noteEntry, subIndex) => {
              const noteEl = createNoteElement(noteEntry.note, "slot", {
                slotSubIndex: subIndex,
                accented: noteEntry.accented,
                hideLabel: true
              });
              duo.appendChild(noteEl);
            });

            const duoLabel = document.createElement("span");
            duoLabel.className = "slot-duo-label";
            duoLabel.textContent = notes.slice(0, 2).map((entry) => getNoteCode(entry.note)).join(" + ");

            slotEl.appendChild(duo);
            slotEl.appendChild(duoLabel);
          }
        });
        renderMeasureOverlays();
      }

      function createNoteElement(noteId, zone, options = {}) {
        const el = document.createElement("button");
        el.type = "button";
        el.className = "note " + (zone === "bank" ? "bank-note" : "slot-note");
        el.dataset.note = noteId;
        if (zone === "slot") {
          el.dataset.slotNote = "1";
          const accented = Boolean(options.accented);
          el.dataset.accented = accented ? "1" : "0";
          if (accented) el.classList.add("accented");
          if (Number.isInteger(options.slotSubIndex)) {
            el.dataset.slotSubIndex = String(options.slotSubIndex);
          }
        }
        el.style.setProperty("--note-color", NOTE_COLORS[noteId] || "#8fa3d8");
        el.setAttribute("aria-label", "Bell " + getNoteLabel(noteId));
        const labelText = options.labelText || getNoteLabel(noteId);
        const hideLabel = Boolean(options.hideLabel);

        const asset = NOTE_ASSETS[noteId];
        if (asset && asset.image) {
          el.classList.add("has-image");
          const imagePath = options.active && asset.activeImage ? asset.activeImage : asset.image;

          const img = document.createElement("img");
          img.className = "note-art";
          img.src = encodeAssetPath(resolveAssetByKind("image", imagePath));
          img.alt = "";
          img.draggable = false;
          img.addEventListener("error", () => {
            img.remove();
            el.classList.remove("has-image");
            el.textContent = labelText;
          });

          const label = document.createElement("span");
          label.className = "note-label";
          label.textContent = labelText;

          el.appendChild(img);
          if (!hideLabel) el.appendChild(label);
        } else {
          el.textContent = labelText;
        }

        if (zone === "slot" && !options.active && Number.isInteger(options.slotSubIndex)) {
          const accentToggle = document.createElement("button");
          accentToggle.type = "button";
          accentToggle.className = "accent-toggle-btn";
          accentToggle.textContent = "^";
          accentToggle.setAttribute("aria-label", "Toggle accent");
          accentToggle.dataset.accentToggle = "1";
          el.appendChild(accentToggle);
        }

        return el;
      }

      function onPointerDown(event) {
        if (event.target.closest(".accent-toggle-btn")) return;
        const noteEl = event.target.closest(".note");
        if (!noteEl) return;
        if (refs.gameScreen.hidden) return;

        // If we are playing, allow drag edits but stop playback first.
        if (isPlaying || isCountingIn) stopMelody();

        event.preventDefault();
        unlockAudio();

        const noteId = noteEl.dataset.note;
        const sourceSlot = noteEl.closest(".slot");
        const fromSlotIndex = sourceSlot ? Number(sourceSlot.dataset.index) : null;
        const fromSlotSubIndex = sourceSlot ? Number(noteEl.dataset.slotSubIndex || "0") : null;
        if (sourceSlot && event.shiftKey && Number.isInteger(fromSlotSubIndex)) {
          event.preventDefault();
          const before = cloneTimeline(slotNotes);
          const toggled = toggleAccentOnBeat(fromSlotIndex, fromSlotSubIndex);
          if (!toggled) return;
          renderSlots();
          pushUndoSnapshot(before);
          updateUndoButton();
          showMessage((toggled.accented ? "Accent on: " : "Accent off: ") + getNoteCode(toggled.note), 850);
          return;
        }
        const noteEntry = {
          note: noteId,
          accented: noteEl.dataset.accented === "1"
        };
        const rect = noteEl.getBoundingClientRect();

        // Light tap feedback on pick-up.
        playNoteSound(noteEntry);

        const ghost = createNoteElement(noteEntry.note, "slot", {
          active: true,
          accented: noteEntry.accented
        });
        ghost.classList.add("drag-ghost");
        ghost.style.width = rect.width + "px";
        ghost.style.height = rect.height + "px";
        document.body.appendChild(ghost);

        dragState = {
          pointerId: event.pointerId,
          noteEntry: cloneNoteEntry(noteEntry),
          fromSlotIndex,
          fromSlotSubIndex,
          copyMode: Boolean(fromSlotIndex !== null && event.altKey),
          ghost,
          offsetX: event.clientX - rect.left,
          offsetY: event.clientY - rect.top,
          previewSlotIndex: null
        };

        moveGhost(event.clientX, event.clientY);
        clearDragPreview();
        window.addEventListener("pointermove", onPointerMove, { passive: false });
        window.addEventListener("pointerup", onPointerUp);
        window.addEventListener("pointercancel", onPointerUp);
      }

      function onPointerMove(event) {
        if (!dragState || event.pointerId !== dragState.pointerId) return;
        event.preventDefault();
        moveGhost(event.clientX, event.clientY);
        const target = slotTargetAtPoint(event.clientX, event.clientY);
        const copyMode = Boolean(dragState.copyMode || event.altKey);
        showDragPreview(target, dragState.noteEntry, dragState.fromSlotIndex, dragState.fromSlotSubIndex, copyMode);
      }

      function onPointerUp(event) {
        if (!dragState || event.pointerId !== dragState.pointerId) return;
        event.preventDefault();

        const { noteEntry, fromSlotIndex, fromSlotSubIndex, ghost } = dragState;
        const copyMode = Boolean(dragState.copyMode || event.altKey);
        const target = slotTargetAtPoint(event.clientX, event.clientY);
        const before = cloneTimeline(slotNotes);
        let changed = false;

        if (target) {
          const targetSlot = target.slotIndex;
          // From bank: copy into slot. From slot: move selected note between slots.
          if (fromSlotIndex !== null && fromSlotIndex !== targetSlot && !copyMode) {
            removeNoteFromBeat(fromSlotIndex, fromSlotSubIndex, noteEntry.note);
            changed = true;
          }
          const placeResult = placeNoteInBeat(
            targetSlot,
            noteEntry,
            target.dropSide,
            (fromSlotIndex === targetSlot && !copyMode) ? fromSlotSubIndex : null
          );
          if (placeResult.changed) {
            changed = true;
            if (placeResult.type === "single") {
              showMessage("Beat " + (targetSlot + 1) + " set to " + getNoteCode(noteEntry.note), 800);
            } else if (placeResult.type === "pair") {
              showMessage("Beat " + (targetSlot + 1) + ": " + placeResult.notes.map((entry) => getNoteCode(entry.note)).join(" + "), 900);
            } else {
              showMessage("Beat " + (targetSlot + 1) + " updated.", 800);
            }
          }
        } else if (fromSlotIndex !== null && !copyMode) {
          removeNoteFromBeat(fromSlotIndex, fromSlotSubIndex, noteEntry.note);
          changed = true;
          showMessage("Removed " + getNoteCode(noteEntry.note), 800);
        }

        if (changed) {
          pushUndoSnapshot(before);
          updateUndoButton();
        }

        ghost.remove();
        dragState = null;
        clearDragPreview();

        window.removeEventListener("pointermove", onPointerMove);
        window.removeEventListener("pointerup", onPointerUp);
        window.removeEventListener("pointercancel", onPointerUp);

        renderSlots();
      }

      function moveGhost(clientX, clientY) {
        if (!dragState) return;
        dragState.ghost.style.left = clientX - dragState.offsetX + "px";
        dragState.ghost.style.top = clientY - dragState.offsetY + "px";
      }

      function slotTargetAtPoint(clientX, clientY) {
        const slots = refs.slotsGrid.querySelectorAll(".slot");
        for (const slot of slots) {
          const r = slot.getBoundingClientRect();
          if (clientX >= r.left && clientX <= r.right && clientY >= r.top && clientY <= r.bottom) {
            const dropSide = clientX < (r.left + r.width / 2) ? "left" : "right";
            return {
              slotIndex: Number(slot.dataset.index),
              dropSide
            };
          }
        }
        return null;
      }

      function showDragPreview(target, noteEntry, fromSlotIndex, fromSlotSubIndex, copyMode) {
        clearDragPreview();
        if (!target || !Number.isInteger(target.slotIndex)) return;

        const slotEl = refs.slotsGrid.querySelector('.slot[data-index="' + target.slotIndex + '"]');
        if (!slotEl) return;

        slotEl.classList.add("previewing");
        const preview = document.createElement("div");
        preview.className = "slot-preview";
        const previewNotes = getPreviewNotesForTarget(target, noteEntry, fromSlotIndex, fromSlotSubIndex, copyMode);
        if (!previewNotes.length) return;

        if (previewNotes.length === 1) {
          const noteEl = createNoteElement(previewNotes[0].note, "slot", {
            slotSubIndex: 0,
            active: true,
            accented: previewNotes[0].accented
          });
          preview.appendChild(noteEl);
        } else {
          const duo = document.createElement("div");
          duo.className = "slot-duo";
          previewNotes.slice(0, 2).forEach((previewNoteEntry, subIndex) => {
            const noteEl = createNoteElement(previewNoteEntry.note, "slot", {
              slotSubIndex: subIndex,
              active: true,
              accented: previewNoteEntry.accented,
              hideLabel: true
            });
            duo.appendChild(noteEl);
          });

          const duoLabel = document.createElement("span");
          duoLabel.className = "slot-duo-label";
          duoLabel.textContent = previewNotes.slice(0, 2).map((entry) => getNoteCode(entry.note)).join(" + ");

          preview.appendChild(duo);
          preview.appendChild(duoLabel);
        }

        slotEl.appendChild(preview);
      }

      function clearDragPreview() {
        refs.slotsGrid.querySelectorAll(".slot.previewing").forEach((slotEl) => slotEl.classList.remove("previewing"));
        refs.slotsGrid.querySelectorAll(".slot-preview").forEach((el) => el.remove());
      }

      function getPreviewNotesForTarget(target, noteEntry, fromSlotIndex, fromSlotSubIndex, copyMode) {
        const targetNotes = getBeatNotes(target.slotIndex);
        const localSubIndex = (fromSlotIndex === target.slotIndex && !copyMode) ? fromSlotSubIndex : null;
        return computePlacedBeatNotes(targetNotes, noteEntry, target.dropSide, localSubIndex);
      }

      function onKeyDown(event) {
        if (refs.gameScreen.hidden) return;
        if (event.code === "Space") {
          if (event.repeat) return;
          if (isTypingContext(event.target)) return;
          event.preventDefault();
          if (isPlaying || isCountingIn) {
            stopMelody();
            showMessage("Stopped.", 700);
          } else {
            unlockAudio();
            preloadAudioAssets();
            playMelody();
          }
          return;
        }
        if (useChromatic) return;
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.repeat) return;
        if (isTypingContext(event.target)) return;

        const noteId = C_MAJOR_KEYBOARD_DIGITS[event.code];
        if (!noteId) return;

        event.preventDefault();
        unlockAudio();
        preloadAudioAssets();
        playNoteSound(noteId);
        flashBankNote(noteId);
      }

      function flashBankNote(noteId) {
        const bankNote = Array.from(refs.bankGrid.querySelectorAll(".bank-note")).find((el) => el.dataset.note === noteId);
        if (!bankNote) return;

        setNoteElementActive(bankNote, true);
        setTimeout(() => setNoteElementActive(bankNote, false), 170);
      }

      function isTypingContext(target) {
        const active = document.activeElement;
        return isTextEditingElement(active) || isTextEditingElement(target);
      }

      function isTextEditingElement(el) {
        if (!el || !(el instanceof HTMLElement)) return false;
        if (el.isContentEditable) return true;

        const tag = el.tagName;
        if (tag === "TEXTAREA") return true;
        if (tag !== "INPUT") return false;

        const type = (el.getAttribute("type") || "text").toLowerCase();
        return !["button", "checkbox", "color", "file", "hidden", "image", "radio", "range", "reset", "submit"].includes(type);
      }

      function playMelody() {
        if (isPlaying || isCountingIn) stopMelody();

        const celebrationKey = getCelebrationKeyForCurrentComposition();
        const countInBeats = countInBars * 4;
        if (countInBeats > 0) {
          startCountIn(countInBeats, () => {
            startPlaybackCycle(celebrationKey);
          });
          return;
        }

        startPlaybackCycle(celebrationKey);
      }

      function startPlaybackCycle(celebrationKey) {
        isPlaying = true;
        refs.playBtn.disabled = true;
        if (celebrationKey) {
          celebratedCompositionKey = celebrationKey;
          triggerMicroCelebration();
        }
        showMessage("Playing at " + tempoBpm + " BPM", 900);
        schedulePlaybackCycle();
      }

      function startCountIn(totalBeats, onComplete) {
        if (totalBeats <= 0) {
          onComplete();
          return;
        }

        isCountingIn = true;
        refs.playBtn.disabled = true;
        refs.countInOverlay.hidden = false;
        updateCountInOverlay(1);
        showMessage("Count-in...", Math.max(700, totalBeats * getBeatMs()));

        const beatMs = getBeatMs();
        for (let beat = 0; beat < totalBeats; beat++) {
          const timer = setTimeout(() => {
            if (!isCountingIn) return;
            const beatInBar = (beat % 4) + 1;
            updateCountInOverlay(beatInBar);
            playCountInClick(beatInBar === 1);
          }, beat * beatMs);
          playTimers.push(timer);
        }

        const doneTimer = setTimeout(() => {
          if (!isCountingIn) return;
          isCountingIn = false;
          refs.countInOverlay.hidden = true;
          onComplete();
        }, totalBeats * beatMs);
        playTimers.push(doneTimer);
      }

      function schedulePlaybackCycle() {
        const totalBeats = getTotalBeats();
        const beatMs = getBeatMs();

        if (totalBeats > 0) {
          scheduleBeatPlayback(0, beatMs);
        }

        for (let beat = 1; beat < totalBeats; beat++) {
          const timer = setTimeout(() => {
            scheduleBeatPlayback(beat, beatMs);
          }, beat * beatMs);
          playTimers.push(timer);
        }

        const endTimer = setTimeout(() => {
          clearBeatHighlight();
          clearPlayingNotes();
          if (loopPlayback && isPlaying) {
            playTimers = [];
            schedulePlaybackCycle();
            return;
          }
          isPlaying = false;
          refs.playBtn.disabled = false;
          playTimers = [];
        }, totalBeats * beatMs + 40);
        playTimers.push(endTimer);
      }

      function scheduleBeatPlayback(beat, beatMs) {
        highlightBeat(beat);
        const notes = getBeatNotes(beat);
        if (!notes.length) return;

        playNoteSound(notes[0]);
        animatePlayedNote(beat, 0, Math.max(130, Math.round(beatMs * 0.42)));

        if (notes.length > 1) {
          const eighthTimer = setTimeout(() => {
            if (!isPlaying) return;
            playNoteSound(notes[1]);
            animatePlayedNote(beat, 1, Math.max(120, Math.round(beatMs * 0.38)));
          }, Math.round(beatMs / 2));
          playTimers.push(eighthTimer);
        }
      }

      function stopMelody() {
        playTimers.forEach((t) => clearTimeout(t));
        playTimers = [];
        isPlaying = false;
        isCountingIn = false;
        refs.playBtn.disabled = false;
        refs.playBtn.classList.remove("micro-celebrate", "micro-celebrate-reduced");
        document.querySelectorAll(".micro-burst").forEach((el) => el.remove());
        clearBeatHighlight();
        clearPlayingNotes();
        refs.playhead.hidden = true;
        refs.countInOverlay.hidden = true;
      }

      function updateCountInOverlay(activeBeat) {
        const current = clamp(Number(activeBeat) || 1, 1, 4);
        refs.countInOverlay.innerHTML =
          'Count-in: ' +
          [1, 2, 3, 4]
            .map((beat) => '<span class="count-step' + (beat === current ? ' active' : '') + '">' + beat + '</span>')
            .join(" ");
      }

      function playCountInClick(isDownbeat) {
        if (!audioCtx) {
          playFallbackTap();
          return;
        }
        const now = audioCtx.currentTime;
        tone(isDownbeat ? 1320 : 980, now, 0.042, "square", isDownbeat ? 0.12 : 0.085);
      }

      function hasAnyPlacedNotes() {
        return slotNotes.some((beatValue) => normalizeBeatValue(beatValue).length > 0);
      }

      function getCompositionPlayKey() {
        return JSON.stringify(
          slotNotes.map((beatValue) => {
            const notes = normalizeBeatValue(beatValue).slice(0, 2);
            return notes.map((entry) => ({
              note: entry.note,
              accented: entry.accented ? 1 : 0
            }));
          })
        );
      }

      function getCelebrationKeyForCurrentComposition() {
        if (!hasAnyPlacedNotes()) return "";
        const nextKey = getCompositionPlayKey();
        if (!nextKey || nextKey === celebratedCompositionKey) return "";
        return nextKey;
      }

      function triggerMicroCelebration() {
        if (!refs.playBtn) return;
        const prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        refs.playBtn.classList.remove("micro-celebrate", "micro-celebrate-reduced");
        void refs.playBtn.offsetWidth;
        refs.playBtn.classList.add(prefersReduced ? "micro-celebrate-reduced" : "micro-celebrate");

        const removePulse = setTimeout(() => {
          refs.playBtn.classList.remove("micro-celebrate", "micro-celebrate-reduced");
        }, 820);
        playTimers.push(removePulse);

        if (prefersReduced) return;

        const palette = ["#58d36f", "#30c8c9", "#5b6bff", "#f4b44f", "#ff9f43", "#ff5bbd"];
        const rect = refs.playBtn.getBoundingClientRect();
        const burst = document.createElement("div");
        burst.className = "micro-burst";
        burst.style.left = (rect.left + rect.width / 2) + "px";
        burst.style.top = (rect.top + rect.height / 2) + "px";

        for (let i = 0; i < 8; i++) {
          const dot = document.createElement("span");
          const angle = (Math.PI * 2 * i) / 8;
          const radius = 16 + (i % 3) * 5;
          dot.className = "micro-burst-dot";
          dot.style.setProperty("--dx", (Math.cos(angle) * radius) + "px");
          dot.style.setProperty("--dy", (Math.sin(angle) * radius) + "px");
          dot.style.setProperty("--delay", (i * 14) + "ms");
          dot.style.setProperty("--dot-color", palette[i % palette.length]);
          burst.appendChild(dot);
        }

        document.body.appendChild(burst);
        const cleanup = setTimeout(() => burst.remove(), 860);
        playTimers.push(cleanup);
      }

      function highlightBeat(beatIndex) {
        const slots = refs.slotsGrid.querySelectorAll(".slot");
        slots.forEach((slot, i) => {
          slot.classList.toggle("playing", i === beatIndex);
        });
        movePlayheadToBeat(beatIndex);
      }

      function clearBeatHighlight() {
        refs.slotsGrid.querySelectorAll(".slot").forEach((slot) => {
          slot.classList.remove("playing");
        });
        refs.playhead.hidden = true;
      }

      function renderMeasureOverlays() {
        if (!refs.measureOverlays || !refs.slotsGrid) return;
        refs.measureOverlays.innerHTML = "";

        const slots = Array.from(refs.slotsGrid.querySelectorAll(".slot"));
        if (!slots.length) {
          refs.measureOverlays.style.width = "0px";
          refs.measureOverlays.style.height = "0px";
          return;
        }

        const gapPx = getCssPx("--gap", 10);
        refs.measureOverlays.style.width = (refs.slotsGrid.scrollWidth + gapPx) + "px";
        refs.measureOverlays.style.height = refs.slotsGrid.scrollHeight + "px";

        for (let i = 0; i < slots.length; i += 4) {
          const slot = slots[i];
          if (!slot) continue;
          const measureNum = document.createElement("span");
          measureNum.className = "measure-num";
          measureNum.textContent = String(Math.floor(i / 4) + 1);
          measureNum.style.left = (slot.offsetLeft - 10) + "px";
          measureNum.style.top = (slot.offsetTop - 16) + "px";
          refs.measureOverlays.appendChild(measureNum);
        }

        for (let i = 3; i < slots.length; i += 4) {
          const slot = slots[i];
          if (!slot) continue;
          const next = slots[i + 1] || null;
          const sameRow = next && next.offsetTop === slot.offsetTop;
          const rightEdge = slot.offsetLeft + slot.offsetWidth;
          const centerX = sameRow
            ? ((rightEdge + next.offsetLeft) / 2)
            : (rightEdge + (gapPx * 0.5));

          const line = document.createElement("span");
          line.className = "measure-line";
          line.style.left = (centerX - 1) + "px";
          line.style.top = (slot.offsetTop + (slot.offsetHeight * 0.15)) + "px";
          line.style.height = (slot.offsetHeight * 0.7) + "px";
          refs.measureOverlays.appendChild(line);
        }
      }

      function movePlayheadToBeat(beatIndex) {
        const slot = refs.slotsGrid.querySelector('.slot[data-index="' + beatIndex + '"]');
        if (!slot) return;

        const wrapRect = refs.slotsWrap.getBoundingClientRect();
        const slotRect = slot.getBoundingClientRect();
        const left = slotRect.left - wrapRect.left + refs.slotsWrap.scrollLeft + (slotRect.width / 2);
        const top = slotRect.top - wrapRect.top + refs.slotsWrap.scrollTop + 6;

        refs.playhead.hidden = false;
        refs.playhead.style.left = left + "px";
        refs.playhead.style.top = top + "px";
      }

      function animatePlayedNote(beatIndex, subIndex, durationMs) {
        const selector = '.slot[data-index="' + beatIndex + '"] .slot-note[data-slot-sub-index="' + subIndex + '"]';
        const noteEl = refs.slotsGrid.querySelector(selector);
        if (!noteEl) return;

        setNoteElementActive(noteEl, true);
        const timer = setTimeout(() => setNoteElementActive(noteEl, false), durationMs);
        playTimers.push(timer);
      }

      function setNoteElementActive(noteEl, active) {
        if (!noteEl) return;
        const noteId = noteEl.dataset.note;
        const asset = NOTE_ASSETS[noteId];
        if (!asset) return;

        noteEl.classList.toggle("note-playing", Boolean(active));
        const img = noteEl.querySelector(".note-art");
        if (img && asset.image) {
          const path = active && asset.activeImage ? asset.activeImage : asset.image;
          img.src = encodeAssetPath(resolveAssetByKind("image", path));
        }

        if (active) {
          activeNoteEls.add(noteEl);
        } else {
          activeNoteEls.delete(noteEl);
        }
      }

      function clearPlayingNotes() {
        activeNoteEls.forEach((noteEl) => setNoteElementActive(noteEl, false));
        activeNoteEls.clear();
      }

      function showMessage(text, ms) {
        clearTimeout(messageTimer);
        refs.message.textContent = text;
        refs.message.classList.add("show");
        messageTimer = setTimeout(() => refs.message.classList.remove("show"), ms || 900);
      }

      function getNoteLabel(noteId) {
        const sharpName = NOTE_LABELS_SHARP[noteId] || noteId;
        if (!useFlats) return sharpName;
        return NOTE_LABELS_FLAT[noteId] || sharpName;
      }

      function getNoteCode(noteId) {
        const label = getNoteLabel(noteId);
        if (label.startsWith("Low ")) return "Lo " + label.slice(4);
        if (label.startsWith("High ")) return "Hi " + label.slice(5);
        return label;
      }

      function encodeAssetPath(path) {
        return encodeURI(path).replace(/#/g, "%23");
      }

      function normalizeBaseUrl(baseUrl) {
        if (typeof baseUrl !== "string") return "";
        const trimmed = baseUrl.trim();
        if (!trimmed) return "";
        return trimmed.endsWith("/") ? trimmed : (trimmed + "/");
      }

      function fileNameFromPath(path) {
        if (!path || typeof path !== "string") return "";
        return path.split("/").pop() || "";
      }

      function normalizeRelativeAssetPath(path) {
        if (!path || typeof path !== "string") return "";
        return path.replace(/^\.?\//, "");
      }

      function resolveAssetByKind(kind, rawPath) {
        if (!rawPath || typeof rawPath !== "string") return rawPath;
        if (/^https?:\/\//i.test(rawPath) || rawPath.startsWith("data:")) return rawPath;

        const normalizedPath = normalizeRelativeAssetPath(rawPath);
        const fileName = fileNameFromPath(rawPath);
        if (!normalizedPath) return rawPath;

        if (kind === "image" && shopifyImageBase) return shopifyImageBase + normalizedPath;
        if (kind === "sound" && shopifySoundBase) {
          if (shopifyFilesSoundBase && fileName) return shopifyFilesSoundBase + fileName;
          if (soundBaseIsThemeAssets && fileName) return shopifySoundBase + fileName;
          return shopifySoundBase + normalizedPath;
        }
        if (kind === "sound" && shopifyFilesSoundBase && fileName) return shopifyFilesSoundBase + fileName;
        return rawPath;
      }

      function getSoundCandidates(rawPath) {
        const candidates = [];
        const seen = new Set();
        const add = (url) => {
          if (!url || typeof url !== "string") return;
          const trimmed = url.trim();
          if (!trimmed || seen.has(trimmed)) return;
          seen.add(trimmed);
          candidates.push(trimmed);
        };

        const normalizedPath = normalizeRelativeAssetPath(rawPath);
        const fileName = fileNameFromPath(rawPath);
        if (!fileName) return candidates;

        if (shopifyFilesSoundBase) {
          add(shopifyFilesSoundBase + fileName);
          return candidates;
        }

        if (shopifySoundBase) {
          if (soundBaseIsThemeAssets) {
            // Shopify theme assets are flat; do not request subfolder paths.
            add(shopifySoundBase + fileName);
          } else {
            add(shopifySoundBase + normalizedPath);
            if (normalizedPath !== fileName) add(shopifySoundBase + fileName);
          }
        } else {
          add(normalizedPath);
          if (!/^mp3\//i.test(normalizedPath)) add("mp3/" + fileName);
          add(fileName);
        }
        return candidates;
      }

      function setMeasures(nextMeasures) {
        const clamped = clamp(nextMeasures, MIN_MEASURES, MAX_MEASURES);
        if (clamped === measures) {
          updateSettingDisplays();
          return;
        }

        stopMelody();
        const nextTotal = clamped * 4;
        if (nextTotal > slotNotes.length) {
          slotNotes = slotNotes.concat(new Array(nextTotal - slotNotes.length).fill(null));
        } else {
          slotNotes = slotNotes.slice(0, nextTotal);
        }
        measures = clamped;
        updateSettingDisplays();
        updateMetaText();
        buildSlots();
      }

      function setNameMode(flatsEnabled) {
        useFlats = Boolean(flatsEnabled);
        updateNameModeButtons();
        buildBank();
        renderSlots();
      }

      function setScaleMode(chromaticEnabled) {
        useChromatic = Boolean(chromaticEnabled);
        updateScaleModeButtons();
        const removed = sanitizeSlotNotesForScale();
        buildBank();
        renderSlots();
        if (removed > 0) {
          showMessage("Removed " + removed + " out-of-scale note" + (removed === 1 ? "" : "s") + ".", 1200);
        }
      }

      function setCountInBars(nextBars) {
        countInBars = clamp(Number(nextBars) || 0, 0, 2);
        updateCountInButtons();
      }

      function updateSettingDisplays() {
        refs.measureSlider.value = String(measures);
        refs.tempoSlider.value = String(tempoBpm);
        refs.measureValue.textContent = String(measures);
        refs.tempoValue.textContent = String(tempoBpm);
      }

      function updateScaleModeButtons() {
        refs.cMajorModeBtn.classList.toggle("active", !useChromatic);
        refs.chromaticModeBtn.classList.toggle("active", useChromatic);
        refs.noteNamesGroup.hidden = !useChromatic;
      }

      function updateNameModeButtons() {
        refs.sharpModeBtn.classList.toggle("active", !useFlats);
        refs.flatModeBtn.classList.toggle("active", useFlats);
      }

      function updateCountInButtons() {
        refs.countInOffBtn.classList.toggle("active", countInBars === 0);
        refs.countIn1Btn.classList.toggle("active", countInBars === 1);
        refs.countIn2Btn.classList.toggle("active", countInBars === 2);
      }

      function updateMetaText() {
        const beats = getTotalBeats();
        refs.progressText.textContent = beats + " beats (" + measures + " measures of 4/4) at " + tempoBpm + " BPM";
      }

      function getTotalBeats() {
        return measures * 4;
      }

      function getBeatMs() {
        return Math.round((60 / tempoBpm) * 1000);
      }

      function clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      function cloneNoteEntry(entry) {
        if (!entry || typeof entry !== "object" || typeof entry.note !== "string") return null;
        return { note: entry.note, accented: Boolean(entry.accented) };
      }

      function normalizeNoteEntry(value) {
        if (!value) return null;
        if (typeof value === "string") {
          return value ? { note: value, accented: false } : null;
        }
        if (typeof value === "object" && typeof value.note === "string" && value.note) {
          return { note: value.note, accented: Boolean(value.accented || value.a) };
        }
        return null;
      }

      function noteEntriesEqual(a, b) {
        const x = normalizeNoteEntry(a);
        const y = normalizeNoteEntry(b);
        if (!x || !y) return !x && !y;
        return x.note === y.note && Boolean(x.accented) === Boolean(y.accented);
      }

      function cloneBeatValue(beatValue) {
        const notes = normalizeBeatValue(beatValue).slice(0, 2).map(cloneNoteEntry).filter(Boolean);
        if (!notes.length) return null;
        if (notes.length === 1) return notes[0];
        return notes;
      }

      function cloneTimeline(source) {
        return source.map((beatValue) => cloneBeatValue(beatValue));
      }

      function timelinesEqual(a, b) {
        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
          const x = normalizeBeatValue(a[i]).slice(0, 2);
          const y = normalizeBeatValue(b[i]).slice(0, 2);
          if (x.length !== y.length) return false;
          for (let j = 0; j < x.length; j++) {
            if (!noteEntriesEqual(x[j], y[j])) return false;
          }
        }
        return true;
      }

      function pushUndoSnapshot(snapshot) {
        if (!Array.isArray(snapshot)) return;
        const copy = cloneTimeline(snapshot);
        const last = undoStack.length ? undoStack[undoStack.length - 1] : null;
        if (last && timelinesEqual(last, copy)) return;
        undoStack.push(copy);
        if (undoStack.length > MAX_UNDO) undoStack.shift();
      }

      function updateUndoButton() {
        refs.undoBtn.disabled = undoStack.length === 0;
      }

      function updateLoopButton() {
        refs.loopBtn.classList.toggle("active", loopPlayback);
      }

      function getCssPx(varName, fallback) {
        const raw = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
        const parsed = Number.parseFloat(raw);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      function autoPatternName() {
        const when = new Date();
        const hh = String(when.getHours()).padStart(2, "0");
        const mm = String(when.getMinutes()).padStart(2, "0");
        return "Pattern " + hh + ":" + mm;
      }

      function getNoteOrder() {
        return useChromatic ? CHROMATIC_NOTE_ORDER : C_MAJOR_NOTE_ORDER;
      }

      function normalizeBeatValue(value) {
        if (!value) return [];
        if (Array.isArray(value)) return value.map(normalizeNoteEntry).filter(Boolean);
        const single = normalizeNoteEntry(value);
        if (single) return [single];
        return [];
      }

      function getBeatNotes(index) {
        return normalizeBeatValue(slotNotes[index]).slice(0, 2);
      }

      function setBeatNotes(index, notes) {
        const clean = normalizeBeatValue(notes)
          .slice(0, 2)
          .map(cloneNoteEntry)
          .filter(Boolean);
        if (!clean.length) {
          slotNotes[index] = null;
        } else if (clean.length === 1) {
          slotNotes[index] = clean[0];
        } else {
          slotNotes[index] = clean;
        }
      }

      function removeNoteFromBeat(index, subIndex, noteId) {
        const notes = getBeatNotes(index);
        if (!notes.length) return;

        if (Number.isInteger(subIndex) && subIndex >= 0 && subIndex < notes.length) {
          notes.splice(subIndex, 1);
        } else {
          const match = notes.findIndex((entry) => entry.note === noteId);
          if (match >= 0) notes.splice(match, 1);
          else notes.pop();
        }
        setBeatNotes(index, notes);
      }

      function toggleAccentOnBeat(index, subIndex) {
        const notes = getBeatNotes(index);
        if (!Number.isInteger(subIndex) || subIndex < 0 || subIndex >= notes.length) return null;
        notes[subIndex] = {
          note: notes[subIndex].note,
          accented: !Boolean(notes[subIndex].accented)
        };
        setBeatNotes(index, notes);
        return cloneNoteEntry(notes[subIndex]);
      }

      function computePlacedBeatNotes(existingNotes, noteEntry, dropSide, fromSlotSubIndex) {
        const incoming = normalizeNoteEntry(noteEntry);
        if (!incoming) return existingNotes.slice(0, 2).map(cloneNoteEntry).filter(Boolean);
        const notes = existingNotes.slice(0, 2).map(cloneNoteEntry).filter(Boolean);
        if (Number.isInteger(fromSlotSubIndex) && fromSlotSubIndex >= 0 && fromSlotSubIndex < notes.length) {
          notes.splice(fromSlotSubIndex, 1);
        }

        const side = dropSide === "left" ? "left" : "right";
        if (!notes.length) return [cloneNoteEntry(incoming)];
        if (notes.length === 1) {
          return side === "left"
            ? [cloneNoteEntry(incoming), cloneNoteEntry(notes[0])]
            : [cloneNoteEntry(notes[0]), cloneNoteEntry(incoming)];
        }
        return side === "left"
          ? [cloneNoteEntry(incoming), cloneNoteEntry(notes[1])]
          : [cloneNoteEntry(notes[0]), cloneNoteEntry(incoming)];
      }

      function placeNoteInBeat(index, noteEntry, dropSide, fromSlotSubIndex) {
        const before = getBeatNotes(index);
        const next = computePlacedBeatNotes(before, noteEntry, dropSide, fromSlotSubIndex);
        setBeatNotes(index, next);

        const changed = before.length !== next.length || !noteEntriesEqual(before[0], next[0]) || !noteEntriesEqual(before[1], next[1]);
        if (next.length === 1) return { type: "single", notes: next, changed };
        if (before.length < 2) return { type: "pair", notes: next, changed };
        return { type: "replace", notes: next, changed };
      }

      function sanitizeSlotNotesForScale() {
        const allowed = new Set(getNoteOrder());
        let removed = 0;
        slotNotes = slotNotes.map((beatValue) => {
          const validNotes = normalizeBeatValue(beatValue).filter((entry) => {
            const ok = allowed.has(entry.note);
            if (!ok) removed += 1;
            return ok;
          }).slice(0, 2);

          if (!validNotes.length) return null;
          if (validNotes.length === 1) return validNotes[0];
          return validNotes;
        });
        return removed;
      }

      function serializeNoteEntry(entry) {
        const noteEntry = normalizeNoteEntry(entry);
        if (!noteEntry) return "";
        if (!noteEntry.accented) return noteEntry.note;
        return {
          note: noteEntry.note,
          a: 1
        };
      }

      function captureState() {
        return {
          m: measures,
          t: tempoBpm,
          c: useChromatic ? 1 : 0,
          f: useFlats ? 1 : 0,
          ci: countInBars,
          n: slotNotes.map((beatValue) => {
            const notes = normalizeBeatValue(beatValue).slice(0, 2);
            if (!notes.length) return "";
            if (notes.length === 1) return serializeNoteEntry(notes[0]);
            return notes.map(serializeNoteEntry);
          })
        };
      }

      function applyState(state) {
        if (!state || typeof state !== "object") return false;
        const nextMeasures = clamp(Number(state.m) || MIN_MEASURES, MIN_MEASURES, MAX_MEASURES);
        const nextTempo = clamp(Number(state.t) || 100, MIN_BPM, MAX_BPM);
        const nextUseChromatic = !(state.c === 0 || state.c === false);
        const nextUseFlats = state.f === 1 || state.f === true;
        const nextCountInBars = clamp(Number(state.ci) || 0, 0, 2);

        measures = nextMeasures;
        tempoBpm = nextTempo;
        useChromatic = nextUseChromatic;
        useFlats = nextUseFlats;
        countInBars = nextCountInBars;

        const total = getTotalBeats();
        slotNotes = new Array(total).fill(null);
        if (Array.isArray(state.n)) {
          for (let i = 0; i < Math.min(total, state.n.length); i++) {
            const rawBeat = state.n[i];
            const nextNotes = normalizeBeatValue(rawBeat)
              .filter((entry) => NOTE_ASSETS[entry.note])
              .slice(0, 2);
            setBeatNotes(i, nextNotes);
          }
        }
        sanitizeSlotNotesForScale();

        stopMelody();
        celebratedCompositionKey = "";
        undoStack = [];
        updateSettingDisplays();
        updateScaleModeButtons();
        updateNameModeButtons();
        updateCountInButtons();
        updateMetaText();
        buildSlots();
        buildBank();
        updateUndoButton();
        return true;
      }

      function encodeState(state) {
        const json = JSON.stringify(state);
        return btoa(json).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
      }

      function decodeState(token) {
        const normalized = token.replace(/-/g, "+").replace(/_/g, "/");
        const padded = normalized + "===".slice((normalized.length + 3) % 4);
        return JSON.parse(atob(padded));
      }

      function buildShareUrl(state) {
        const url = new URL(window.location.href);
        const token = encodeState(state);
        url.hash = "p=" + token;
        return url.toString();
      }

      function applyStateFromHash() {
        const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : "";
        if (!hash) return false;
        const params = new URLSearchParams(hash);
        const token = params.get("p");
        if (!token) return false;

        try {
          const state = decodeState(token);
          return applyState(state);
        } catch (_) {
          return false;
        }
      }

      async function copyText(text) {
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
          }
        } catch (_) {
          // fall through
        }
        window.prompt("Copy this link:", text);
        return false;
      }

      function printPattern() {
        const title = (refs.patternNameInput.value || "").trim() || autoPatternName();
        const originalTitle = document.title;

        refs.printTitle.textContent = title;
        refs.printTitle.hidden = false;
        document.title = title + " - Bell Composer";

        window.print();

        setTimeout(() => {
          refs.printTitle.hidden = true;
          document.title = originalTitle;
        }, 50);
      }

      function loadSavedPatterns() {
        try {
          const raw = localStorage.getItem(STORAGE_KEY);
          const parsed = raw ? JSON.parse(raw) : [];
          savedPatterns = Array.isArray(parsed) ? parsed : [];
        } catch (_) {
          savedPatterns = [];
        }
      }

      function persistSavedPatterns() {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(savedPatterns));
        } catch (_) {
          // ignore storage write errors
        }
      }

      function renderSavedPatterns() {
        refs.savedList.innerHTML = "";
        if (!savedPatterns.length) {
          const empty = document.createElement("div");
          empty.className = "saved-empty";
          empty.textContent = "No saved patterns yet.";
          refs.savedList.appendChild(empty);
          return;
        }

        savedPatterns.forEach((pattern) => {
          const item = document.createElement("div");
          item.className = "saved-item";

          const meta = document.createElement("div");
          meta.className = "saved-meta";
          const name = document.createElement("span");
          name.textContent = pattern.name || "Untitled Pattern";
          const detail = document.createElement("span");
          const beatCount = pattern && pattern.state && pattern.state.m ? Number(pattern.state.m) * 4 : 0;
          detail.textContent = beatCount + " beats";
          meta.appendChild(name);
          meta.appendChild(detail);

          const actions = document.createElement("div");
          actions.className = "saved-actions";

          const loadBtn = document.createElement("button");
          loadBtn.type = "button";
          loadBtn.className = "teal-btn mini-btn";
          loadBtn.textContent = "Load";
          loadBtn.dataset.action = "load";
          loadBtn.dataset.id = pattern.id;

          const shareBtn = document.createElement("button");
          shareBtn.type = "button";
          shareBtn.className = "teal-btn mini-btn";
          shareBtn.textContent = "Share";
          shareBtn.dataset.action = "share";
          shareBtn.dataset.id = pattern.id;

          const delBtn = document.createElement("button");
          delBtn.type = "button";
          delBtn.className = "red-btn mini-btn";
          delBtn.textContent = "Delete";
          delBtn.dataset.action = "delete";
          delBtn.dataset.id = pattern.id;

          actions.appendChild(loadBtn);
          actions.appendChild(shareBtn);
          actions.appendChild(delBtn);

          item.appendChild(meta);
          item.appendChild(actions);
          refs.savedList.appendChild(item);
        });
      }

      // Manual validation checklist:
      // 1. Count-in Off/1 bar/2 bars from Play and Spacebar; Stop cancels count-in.
      // 2. Shift-click or tap the tiny ^ button toggles accent; playback is louder on accented notes.
      // 3. Save/load/share/print retain accented notes and load older non-accent patterns.
      // 4. First non-empty playback triggers one micro celebration per composition state.

      // ---------- Audio ----------
      function unlockAudio() {
        if (!audioCtx) {
          const Ctx = window.AudioContext || window.webkitAudioContext;
          if (!Ctx) return;
          audioCtx = new Ctx();
        }
        if (audioCtx.state === "suspended") audioCtx.resume();
        primeHtmlAudioPlayback();
      }

      function preloadAudioAssets() {
        if (audioAssetsLoaded) return Promise.resolve();
        if (audioPreloadPromise) return audioPreloadPromise;

        const loadWaiters = [];
        Object.keys(NOTE_ASSETS).forEach((noteId) => {
          const noteAsset = NOTE_ASSETS[noteId];
          if (!noteAsset || !noteAsset.sound) return;
          const player = createNotePlayer(noteAsset.sound, 0.95);
          notePlayers[noteId] = player;
          player.voices.forEach((voice) => {
            loadWaiters.push(waitForAudioReady(voice, 1600));
          });
        });
        audioPreloadPromise = Promise.allSettled(loadWaiters).then(() => {
          audioAssetsLoaded = true;
        });
        return audioPreloadPromise;
      }

      function createNotePlayer(path, baseVolume) {
        const voices = [];
        const voiceCount = Math.max(1, Number(NOTE_VOICES_PER_SOUND) || 1);
        for (let i = 0; i < voiceCount; i++) {
          voices.push(createAudioPlayer(path, baseVolume));
        }
        return {
          voices,
          nextVoiceIndex: 0,
          baseVolume
        };
      }

      function createAudioPlayer(path, volume) {
        const audio = new Audio();
        audio.preload = "auto";
        audio.playsInline = true;
        const candidates = getSoundCandidates(path);
        audio._bcCandidates = candidates;
        audio._bcCandidateIndex = 0;
        audio.src = encodeAssetPath((candidates[0] || resolveAssetByKind("sound", path)));
        audio.addEventListener("error", () => {
          const nextIndex = Number(audio._bcCandidateIndex || 0) + 1;
          const nextUrl = audio._bcCandidates && audio._bcCandidates[nextIndex];
          if (!nextUrl) return;
          audio._bcCandidateIndex = nextIndex;
          audio.src = encodeAssetPath(nextUrl);
          try {
            audio.load();
          } catch (_) {
            // ignore and let fallback synth handle it
          }
        });
        audio.volume = volume;
        try {
          audio.load();
        } catch (_) {
          // ignore and let browser fetch on demand
        }
        return audio;
      }

      function primeHtmlAudioPlayback() {
        if (htmlAudioPrimed) return;
        const players = Object.values(notePlayers).flatMap((player) => {
          if (!player || !Array.isArray(player.voices)) return [];
          return player.voices.filter((voice) => voice && typeof voice.play === "function");
        });
        if (!players.length) return;

        let primedCount = 0;
        players.forEach((sample) => {
          const prevMuted = sample.muted;
          const prevVolume = sample.volume;
          sample.muted = true;
          sample.volume = 0;

          const restore = () => {
            sample.pause();
            try {
              sample.currentTime = 0;
            } catch (_) {
              // ignore currentTime reset failures
            }
            sample.muted = prevMuted;
            sample.volume = prevVolume;
          };

          try {
            const result = sample.play();
            if (result && typeof result.then === "function") {
              result.then(() => {
                primedCount += 1;
                htmlAudioPrimed = primedCount > 0;
              }).catch(() => {
                // leave unprimed so a later user gesture can retry
              }).finally(restore);
            } else {
              primedCount += 1;
              htmlAudioPrimed = primedCount > 0;
              restore();
            }
          } catch (_) {
            restore();
          }
        });
      }

      function waitForAudioReady(audioEl, timeoutMs) {
        return new Promise((resolve) => {
          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            cleanup();
            resolve();
          };
          const cleanup = () => {
            audioEl.removeEventListener("canplaythrough", finish);
            audioEl.removeEventListener("loadeddata", finish);
            audioEl.removeEventListener("error", finish);
            clearTimeout(timer);
          };
          const timer = setTimeout(finish, timeoutMs || 1200);
          audioEl.addEventListener("canplaythrough", finish, { once: true });
          audioEl.addEventListener("loadeddata", finish, { once: true });
          audioEl.addEventListener("error", finish, { once: true });
        });
      }

      function showBootLoader(text) {
        if (!refs.bootLoader) return;
        if (text && refs.bootLoaderText) refs.bootLoaderText.textContent = text;
        refs.bootLoader.hidden = false;
      }

      function hideBootLoader() {
        if (!refs.bootLoader || refs.bootLoader.hidden) return;
        refs.bootLoader.classList.add("done");
        setTimeout(() => {
          refs.bootLoader.hidden = true;
          refs.bootLoader.classList.remove("done");
        }, 180);
      }

      function tone(freq, start, dur, type, vol) {
        if (!audioCtx) return;
        const osc = audioCtx.createOscillator();
        const gain = audioCtx.createGain();
        osc.type = type || "triangle";
        osc.frequency.setValueAtTime(freq, start);
        gain.gain.setValueAtTime(0.0001, start);
        gain.gain.exponentialRampToValueAtTime(vol || 0.12, start + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
        osc.connect(gain);
        gain.connect(audioCtx.destination);
        osc.start(start);
        osc.stop(start + dur + 0.03);
      }

      function playNoteSound(noteValue, options = {}) {
        const normalized = normalizeNoteEntry(noteValue);
        const noteId = normalized ? normalized.note : (typeof noteValue === "string" ? noteValue : "");
        if (!noteId) return;

        const noteAsset = NOTE_ASSETS[noteId];
        if (noteAsset && !noteAsset.sound) {
          return;
        }
        const player = notePlayers[noteId];
        if (!player || !Array.isArray(player.voices) || !player.voices.length) {
          playFallbackTap();
          return;
        }
        const accentMultiplier = normalized && normalized.accented ? 1 : 0.8;
        const gainMultiplier = Number(options.gainMultiplier);
        const safeGain = Number.isFinite(gainMultiplier) && gainMultiplier > 0 ? gainMultiplier : 1;
        const voices = player.voices;
        let clip = null;
        const startIndex = Number(player.nextVoiceIndex || 0) % voices.length;
        for (let i = 0; i < voices.length; i++) {
          const idx = (startIndex + i) % voices.length;
          const voice = voices[idx];
          if (!voice || (voice.ended === false && voice.paused === false)) continue;
          clip = voice;
          player.nextVoiceIndex = (idx + 1) % voices.length;
          break;
        }
        if (!clip) {
          clip = voices[startIndex];
          player.nextVoiceIndex = (startIndex + 1) % voices.length;
        }
        try {
          if (!clip || (!clip.src && !clip.currentSrc)) {
            playFallbackTap();
            return;
          }
          try {
            clip.currentTime = 0;
          } catch (_) {
            // some browsers disallow manual seeking until metadata is ready
          }
          clip.playsInline = true;
          clip.volume = Math.min(1, Number(player.baseVolume || 0.95) * accentMultiplier * safeGain);
          const result = clip.play();
          if (result && typeof result.catch === "function") {
            result.catch(() => playFallbackTap());
          }
        } catch (_) {
          playFallbackTap();
        }
      }

      function playFallbackTap() {
        if (!audioCtx) return;
        tone(820, audioCtx.currentTime, 0.07, "triangle", 0.1);
      }
    })();
